import { Box, SizableText, SmartLink, XStack } from '@my/ui'
import { formatTimeToNow } from 'app/utils/format-time-to-now'
import { NewCommentBlock } from './new-comment.block'
import { NotificationUserImage } from '../../components'

export const NewCommentComponent = (block: NewCommentBlock) => {
  const formattedTime = formatTimeToNow(block.createdAt, false)

  return (
    <SmartLink
      Component={Box}
      href={`/groups/posts/${block.groupPost.id}/${block.comment?.id}`}
      flex={1}
      gap="$2"
      ai="center"
      jc="space-between"
      shadow={false}
      pressable
    >
      <XStack flex={1} ai="center" gap="$2">
        <NotificationUserImage images={[block.creator?.avatar?.sizes?.small?.url || '']} />
        <XStack flex={1} gap="$1.5">
          <SizableText size="$2" fow="600">
            {block.creator.fullName}
          </SizableText>
          <SizableText flex={1} numberOfLines={1} color="$overlay10" size="$2" fow="600">
            replied to your comment
          </SizableText>
        </XStack>
      </XStack>

      <XStack flexShrink={0} ai="center" gap="$2">
        <SizableText size="$2" color="$overlay8">
          {formattedTime}
        </SizableText>
      </XStack>
    </SmartLink>
  )
}
